<div class="container mx-auto p-4">
  <h2 class="text-2xl font-bold mb-4">Project Notes</h2>
  
  <!-- Add/Edit Note Form -->
  <div class="mb-4 p-4 bg-gray-100 rounded">
    <form (ngSubmit)="editingNote ? updateNote(noteForm) : addNote(noteForm)" #noteForm="ngForm">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
       
        <div>
          <label for="author" class="block text-sm font-medium">Author</label>
          <input type="text" id="author" [(ngModel)]="newNote.author" name="author" 
                 class="w-full p-2 border rounded" required>
        </div>
        <div>
          <label for="content" class="block text-sm font-medium">Note Content</label>
          <textarea id="content" [(ngModel)]="newNote.content" name="content" 
                    class="w-full p-2 border rounded" required></textarea>
        </div>
      </div>
      <button type="submit" class="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              [disabled]="!noteForm.valid">{{ editingNote ? 'Update Note' : 'Add Note' }}</button>
      <button type="button" *ngIf="editingNote" (click)="resetForm()" 
              class="mt-4 ml-2 px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700">Cancel</button>
    </form>
  </div>

  <!-- Notes Table -->
  <div class="overflow-x-auto">
    <table class="w-full border-collapse bg-white shadow-md rounded">
      <thead>
        <tr class="bg-gray-200">
          <th class="p-3 text-left">ID</th> 
          <th class="p-3 text-left">Date</th>
          <th class="p-3 text-left">Author</th>
          <th class="p-3 text-left">Content</th>
          <th class="p-3 text-left">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let note of notes" class="border-b hover:bg-gray-50">
          <td class="p-3">{{note.id}}</td> 
          <td class="p-3">{{note.date | date:'shortDate'}}</td>
          <td class="p-3">{{note.author}}</td>
          <td class="p-3">{{note.content}}</td>
          <td class="p-3">
            <button (click)="editNote(note)" class="mr-2 text-blue-600 hover:text-blue-800">Edit</button>
            <button (click)="deleteNote(note.id)" class="text-red-600 hover:text-red-800">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>